import { FieldHandler, BoardColumnConfig } from '../types';
import { convertConfigToSheetjs } from '../utils';

export type Config = BoardColumnConfig;

export const handler: FieldHandler<Config> = {
  defaultConfig: {},

  type: 'item-parent-id',

  extractFieldsFromBoard: (board) => {
    return [
      {
        id: 'item-property_parent-id',
        label: 'Parent ID',
      },
    ];
  },

  exportTo: (outputFormat, fieldId, boardItem, board, config) => {
    if (outputFormat === 'sheetjs') {
      return {
        ...convertConfigToSheetjs(config),
        v: boardItem.parent_item?.id,
        t: 'n',
      };
    }
  },
};

export default handler;
